import { http } from '@/http'

/**
 * Lavados de vehículo de flota (DEF-ADM-015 Fase 2).
 * El header X-City-Id lo agrega el interceptor global.
 */
export default {
  // Dashboard por vehículo: último lavado + días sin lavado + alerta.
  status() {
    return http.get('/api/v1/fleet/washes/status')
  },
  // Historial de lavados.
  list(params) {
    return http.get('/api/v1/fleet/washes', { params })
  },
  get(id) {
    return http.get(`/api/v1/fleet/washes/${id}`)
  },
  create(data) {
    return http.post('/api/v1/fleet/washes', data)
  },
  update(id, data) {
    return http.put(`/api/v1/fleet/washes/${id}`, data)
  },
  remove(id) {
    return http.delete(`/api/v1/fleet/washes/${id}`)
  },
  uploadPhoto(id, file) {
    const fd = new FormData()
    fd.append('photo', file)
    return http.post(`/api/v1/fleet/washes/${id}/photo`, fd)
  },
  getPhoto(id) {
    return http.get(`/api/v1/fleet/washes/${id}/photo`)
  }
}
